import {useEffect, useState} from "react"
import {useAccount, useProvider} from "wagmi"
import {ethers} from "ethers"
import { WARRIOR_NFT, synthAbi, nftMap } from '@/utils/abi'

export const useWarrior = () => {
  const [loading, setLoading] = useState(false);
  const [warriors, setWarriors] = useState([]);
  const { address } = useAccount();
  const provider = useProvider();

  const getList = async()=>{
    setLoading(true)
    try {
      const nftContract = new ethers.Contract(WARRIOR_NFT, synthAbi, provider);
      const balance = (await nftContract.balanceOf(address)) * 1;
      const list = await Promise.all(
        Array(balance).fill(1).map(async (_, index) => {
          const tokenId = await nftContract.tokenOfOwnerByIndex(address, index)
          const type = await nftContract.tokenTypes(tokenId)
          return {
            type,
            tokenId: tokenId.toString() * 1,
            address,
            contractAddres: WARRIOR_NFT,
            info: nftMap[type]
          }
        })
      )
      setWarriors(list.sort((a, b) =>  a.tokenId - b.tokenId))
    } catch (e) {
      console.log(e);
    }
    setLoading(false)
  }

  useEffect(() => {
    getList();
  }, [provider, address])

  return {
    loading,
    warriors,
    reload: getList
  }

}